export default __webpack_public_path__ + "static/media/summaryTab.232fcef3.svg";